module.exports = __webpack_public_path__ + "static/img/slaPurpose3.9dd67cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaPurpose3.png
// module id = iVhM
// module chunks = 2